import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Qualtrics } from '@americanexpress/shared-scripts';
import { isNativeMobile } from '@americanexpress/banking-common';

const QualtricsScript = ({ children }) => {
  const isNative = useMemo(() => isNativeMobile(), []);

  return (
    <>
      {!isNative && (
        <Qualtrics
          version="^1.34.0"
          zoneId="ZN_dhZtUGWqHlUlqhT"
          sampleType="pageview"
          sampleRate={100}
          crossOrigin="anonymous"
        />
      )}
      {children}
    </>
  );
};

QualtricsScript.propTypes = {
  children: PropTypes.node.isRequired,
};

export default QualtricsScript;
